import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.span<{ isCircle: boolean; isFilterType: boolean; disabled: boolean }>`
    position: relative;
    margin-bottom: ${rem(15)};
    display: flex;
    align-items: center;
`;

export const Input = styled.input`
    height: ${rem(0)};
    left: 0;
    position: absolute;
    top: 0;
    width: ${rem(0)};
    cursor: pointer;

    &:after {
        width: ${rem(22)};
        height: ${rem(22)};
        border-radius: ${rem(22)};
        top: 0;
        left: 0;
        position: relative;
        background-color: ${({ theme }) => theme.colors.white};
        content: '';
        display: inline-block;
        visibility: visible;
        border: ${rem(1)} solid ${({ theme }) => theme.colors.border};
    }

    &:checked:after {
        width: ${rem(22)};
        height: ${rem(22)};
        border-radius: ${rem(22)};
        top: 0;
        left: 0;
        position: relative;
        background-color: ${({ theme }) => theme.colors.white};
        content: '';
        display: inline-block;
        visibility: visible;
        border: ${rem(6)} solid ${({ theme }) => theme.colors.primary};
    }
`;

export const Label = styled.label<{ isBold?: boolean }>`
    display: block;
    padding-left: ${rem(35)};
    cursor: pointer;
    font-weight: ${(prop) => (prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular)};
`;
